// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/" + chunkId + "." + chunkId + "." + {"435":"b40cd2de","1385":"77b369ec","2589":"d6fdf0fb","4565":"f51d23bb"}[chunkId] + ".css";
};